module.exports = __webpack_public_path__ + "img/layer.84bea6de.svg";